import React, { useState } from "react";
import type { StaffUser } from "../types";

interface Props {
  need: "owner" | "reason";
  users: StaffUser[];
  onCancel: () => void;
  onConfirm: (value: { owner_user_id?: string; reason?: string }) => void;
}

export default function TransitionModal({ need, users, onCancel, onConfirm }: Props) {
  const [ownerId, setOwnerId] = useState("");
  const [reason, setReason] = useState("");

  return (
    <div className="modal-backdrop" onClick={onCancel}>
      <div className="modal" onClick={(e: any) => e.stopPropagation()}>
        {need === "owner" ? (
          <>
            <h3>Asignar responsable</h3>
            <p className="meta">Esta etapa requiere una vendedora/o responsable antes de continuar.</p>
            <select value={ownerId} onChange={(e: any) => setOwnerId(e.target.value)}>
              <option value="">Seleccionar...</option>
              {users.map((u) => (
                <option key={u.id} value={u.id}>
                  {u.full_name}
                </option>
              ))}
            </select>
            <div className="modal-actions">
              <button className="btn-ghost" onClick={onCancel}>
                Cancelar
              </button>
              <button className="btn-primary" disabled={!ownerId} onClick={() => onConfirm({ owner_user_id: ownerId })}>
                Confirmar
              </button>
            </div>
          </>
        ) : (
          <>
            <h3>Motivo de pérdida</h3>
            <p className="meta">Indicá por qué se pierde esta oportunidad.</p>
            <textarea value={reason} onChange={(e: any) => setReason(e.target.value)} rows={3} placeholder="Motivo..." />
            <div className="modal-actions">
              <button className="btn-ghost" onClick={onCancel}>
                Cancelar
              </button>
              <button className="btn-primary" disabled={!reason.trim()} onClick={() => onConfirm({ reason: reason.trim() })}>
                Confirmar
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
